class MonthlyProduction {
  constructor() {
  }

  static factory($resource, config) {
    return $resource(
      config.detailsEndpoint, {}, {
        get: {
          method: 'GET'
        }
      }
    )
  }
}

MonthlyProduction.factory.$inject = ['$resource', 'config']

export default MonthlyProduction